module.exports = __webpack_public_path__ + "static/media/mursion-logo.95425cce.svg";